var map = {
	"./R3Planar-detail.jpg": 6681,
	"./R3Planar-preview.png": 54184,
	"./R6-detail.jpg": 19654,
	"./R6-preview.png": 79897,
	"./SCARA-detail.png": 52676,
	"./SCARA-preview.png": 22987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2004;